import React from 'react'
import { Link } from 'react-router-dom'
import {
    avatar01,
    avatar02,
    avatar03,
    avatar04,
    avatar05,
  } from "../imagepath";
function TopUser() {
  return (
    <div className="row w-full">
          
                <div className="card flex-fill student-space comman-shadow">
                  <div className="card-header d-flex align-items-center">
                    <h5 className="card-title">Top Interface</h5>
                    {/* <ul className="chart-list-out student-ellips">
                      <li className="star-menus">
                        <Link to="#">
                          <i className="fas fa-ellipsis-v" />
                        </Link>
                      </li>
                    </ul> */}
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table star-student table-hover table-center table-borderless table-striped">
                        <thead className="thead-light">
                          <tr>
                           
                            <th>Card User Name</th>
                            <th className="text-center">Location</th>
                            <th className="text-center">View Count</th>
                            <th className="text-center">Percentage</th>
                            {/* <th className="text-end">Year</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                           
                            <td className="text-nowrap">
                              <Link to="/profile" className='flex'>
                                {/* <img
                                  className="rounded-circle"
                                  src={avatar02}
                                  width={25}
                                  alt="Star Students"
                                /> */}
                                John Smith
                              </Link>
                            </td>
                            <td className="text-center">Thirur</td>
                            <td className="text-center">1185</td>
                            <td className="text-center">98%</td>
                            {/* <td className="text-end">
                              <div>2019</div>
                            </td> */}
                          </tr>
                          <tr>
                            
                            <td className="text-nowrap">
                              <Link to="/profile" className='flex'>
                                
                                Jolie Hoskins
                              </Link>
                            </td>
                            <td className="text-center">Aluva</td>
                            <td className="text-center">1195</td>
                            <td className="text-center">99.5%</td>
                            {/* <td className="text-end">
                              <div>2018</div>
                            </td> */}
                          </tr>
                          <tr>
                            
                            <td className="text-nowrap">
                              <Link to="/profile" className='flex'>
                                
                                Pennington Joy
                              </Link>
                            </td>
                            <td className="text-center">Kuttanad</td>
                            <td className="text-center">1196</td>
                            <td className="text-center">99.6%</td>
                            {/* <td className="text-end">
                              <div>2017</div>
                            </td> */}
                          </tr>
                          <tr>
                            
                            <td className="text-nowrap">
                              <Link to="/profile" className='flex'>
                                
                                Millie Marsden
                              </Link>
                            </td>
                            <td className="text-center">kalamassery</td>
                            <td className="text-center">1187</td>
                            <td className="text-center">98.2%</td>
                            {/* <td className="text-end">
                              <div>2016</div>
                            </td> */}
                          </tr>
                          <tr>
                            
                            <td className="text-nowrap">
                              <Link to="/profile" className='flex'>
                                
                                John Smith
                              </Link>
                            </td>
                            <td className="text-center">kakkanad</td>
                            <td className="text-center">1185</td>
                            <td className="text-center">98%</td>
                            {/* <td className="text-end">
                              <div>2015</div>
                            </td> */}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
              
                {/* /Star Students */}
              </div>
              {/* <div className="col-xl-6 d-flex"> */}
                {/* Feed Activity */}
                {/* <div className="card flex-fill comman-shadow">
                  <div className="card-header d-flex align-items-center">
                    <h5 className="card-title ">Student Activity </h5>
                    <ul className="chart-list-out student-ellips">
                      <li className="star-menus">
                        <Link to="#">
                          <i className="fas fa-ellipsis-v" />
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="card-body">
                    <div className="activity-groups">
                      <div className="activity-awards">
                        <div className="award-boxs">
                          <img src={awardicon01} alt="Award" />
                        </div>
                        <div className="award-list-outs">
                          <h4>1st place in "Chess”</h4>
                          <h5>John Doe won 1st place in "Chess"</h5>
                        </div>
                        <div className="award-time-list">
                          <span>1 Day ago</span>
                        </div>
                      </div>
                      <div className="activity-awards">
                        <div className="award-boxs">
                          <img src={awardicon02} alt="Award" />
                        </div>
                        <div className="award-list-outs">
                          <h4>Participated in "Carrom"</h4>
                          <h5>Justin Lee participated in "Carrom"</h5>
                        </div>
                        <div className="award-time-list">
                          <span>2 hours ago</span>
                        </div>
                      </div>
                      <div className="activity-awards">
                        <div className="award-boxs">
                          <img src={awardicon03} alt="Award" />
                        </div>
                        <div className="award-list-outs">
                          <h4>Internation conference in "St.John School"</h4>
                          <h5>
                            Justin Leeattended internation conference in
                            "St.John School"
                          </h5>
                        </div>
                        <div className="award-time-list">
                          <span>2 Week ago</span>
                        </div>
                      </div>
                      <div className="activity-awards mb-0">
                        <div className="award-boxs">
                          <img src={awardicon04} alt="Award" />
                        </div>
                        <div className="award-list-outs">
                          <h4>Won 1st place in "Chess"</h4>
                          <h5>John Doe won 1st place in "Chess"</h5>
                        </div>
                        <div className="award-time-list">
                          <span>3 Day ago</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
                {/* /Feed Activity */}
              {/* </div> */}
            </div>
  )
}

export default TopUser